// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

// Canonical cycle ids are `cycle-<uuid4>` (PRD §Further Notes). The short
// display form drops the `cycle-` prefix and keeps the first 8 hex of the
// uuid (its first block), intended to render monospace.
//
// Invariant (PRD §Invariants — lossless): `full` is always the original id
// verbatim, so the complete id is recoverable for hover / copy. A
// non-conforming id degrades gracefully — returned as-is in both fields, never throws.

export interface CycleIdDisplay {
  short: string
  full: string
}

const CANONICAL_CYCLE_ID = /^cycle-([0-9a-f]{8})-/i

export function formatCycleId(id: string): CycleIdDisplay {
  const match = CANONICAL_CYCLE_ID.exec(id)
  return { short: match ? match[1] : id, full: id }
}
